import { ChannelTypeEnum } from '~/enums/conversations';
import {
  MessagesIcon,
  SMSIcon,
  TeamsIcon,
  WhatsappIcon,
} from '~/assets/svgIcons';

const getChannelIconById = (channelId: ChannelTypeEnum) => {
  let icon = MessagesIcon;

  switch (channelId) {
    case ChannelTypeEnum.SMS:
      icon = SMSIcon;
      break;
    case ChannelTypeEnum.WHATSAPP:
      icon = WhatsappIcon;
      break;
    case ChannelTypeEnum.INTERNAL:
      icon = TeamsIcon;
      break;
    default:
      icon = MessagesIcon;
  }

  return icon;
};

export { getChannelIconById };
